// React Query
import { UseQueryResult } from '@tanstack/react-query';
// Http Methods
import { getRequest as get } from '../utils/HttpMethods';

// Interface
import { isPermission, Permission } from 'interfaces';
import { useListQuery } from '../utils/queries';

export const permissionQueryKeys = {
  all: ['permissions'],
};

/**
 * @description Fetches the list of permissions from the server.
 * @returns {Promise<Permission[] | null>} A promise that resolves to an array of permissions or null.
 */
export const listPermissions = async (): Promise<Permission[] | null> =>
  await get<Permission[]>('QBilling', `/resource/permission`);

/**
 * @description Hook to fetch the list of permissions from the server.
 * @returns {UseQueryResult<Permission[], Error>} The result of the query.
 */
export const useListPermissions = (): UseQueryResult<Permission[], Error> => {
  return useListQuery<Permission>({
    queryKey: permissionQueryKeys.all,
    fetchFunction: listPermissions,
    functionName: 'listPermissions',
    isEntity: isPermission,
    enabled: true,
    displayNotification: true,
  });
};
